// extracted by mini-css-extract-plugin
export default {"container":"aTQdJq","hoverable":"bTQdJq","outsideIcon":"cTQdJq"};